import React from 'react'
import { Backdrop, Box } from '@mui/material'
import Loader from './Loader'

const LoadingOverlay = ({ children, loading }) => {
  return (
    <Box position="relative">
      <Backdrop sx={{ color: '#fff', zIndex: 99999 }} open={loading}>
        <Loader />
      </Backdrop>
      {children}
    </Box>
  )
}

export default LoadingOverlay
